import React, { useCallback } from 'react'
import useGetLoans from '../hooks/useGetLoans'
import { useParams } from 'react-router-dom'
import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'
import InfiniteScroll from 'react-infinite-scroll-component'
import {
    FetchNextPageOptions,
    InfiniteData,
    InfiniteQueryObserverResult,
} from 'react-query'
import { CiSearch } from 'react-icons/ci'
interface ILoansProps {
    data: InfiniteData<IMoneyPoolFundLoans> | undefined
    isLoading: boolean
    fetchNextPage: (
        options?: FetchNextPageOptions | undefined
    ) => Promise<InfiniteQueryObserverResult<IMoneyPoolFundLoans, unknown>>
    isError: boolean
    setSearchLoans: React.Dispatch<React.SetStateAction<string>>
    searchLoan: string
    setSearchLoan: React.Dispatch<React.SetStateAction<string>>
}
export default function Loans({
    data,
    isLoading,
    fetchNextPage,
    isError,
    setSearchLoans,
    searchLoan,
    setSearchLoan,
}: ILoansProps) {
    const { id } = useParams()

    return (
        <>
            <div className="flex h-[25px]">
                <input
                    type="text"
                    className=" w-full outline-0 border border-green-1 rounded-full px-2 py-1 ml-3"
                    onChange={(e) => setSearchLoan(e.target.value)}
                    value={searchLoan}
                    placeholder="جستجو..."
                />
                <CiSearch
                    className=" text-green-1  w-8 h-full cursor-pointer"
                    onClick={() => {
                        setSearchLoans(searchLoan)
                    }}
                />
            </div>
            {!isLoading && data ? (
                <InfiniteScroll
                    next={fetchNextPage}
                    hasMore={
                        data
                            ? data?.pages[data.pages.length - 1].next
                                ? true
                                : false
                            : false
                    }
                    dataLength={
                        data ? data.pages.flatMap((x) => x.results).length : 0
                    }
                    loader={<DotsLoading />}
                >
                    <div>
                        {data.pages
                            .flatMap((x) => x.results)
                            .map((item) => (
                                <Item item={item} key={item.id} />
                            ))}
                    </div>
                </InfiniteScroll>
            ) : (
                <>
                    {isError ? (
                        <p className=" text-center">وامی وجود ندارد</p>
                    ) : (
                        <DotsLoading />
                    )}
                </>
            )}
        </>
    )
}
